import React from "react"
import styles from "../ResortApartments/resortApartments.module.scss"

export function Preview3D({ url }) {
    if (!url) {
        return null
    }

    return (
        <div className={styles.previewContent}>
            <iframe
                loading="lazy"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                className={styles.iframe}
                width="1280"
                height="360"
                src={url}
                frameBorder="0"
                allowFullScreen
                id="showcase_iframe"
            />
            3d walkthrough courtesy of dvcrequest.com
        </div>
    )
}
